import PropTypes from 'prop-types';
import React from 'react';

import StarRatingComponent from './components/StarRating';

import { FullStar, HalfStar } from './components/Stars';

const StarRating = ({
  className,
  editing,
  emptyStarColor,
  name,
  onChange,
  onStarClick,
  small,
  starCount,
  starColor,
  value,
  large,
  showTooltip,
}) => (
  <StarRatingComponent
    className={className}
    name={name}
    value={value}
    starCount={starCount}
    renderStarIcon={(index, _value) => {
      // If value has a decimal place in it:
      if (Math.ceil(_value) === index && _value % 1 !== 0) {
        return <HalfStar starColor={starColor} emptyStarColor={emptyStarColor} />;

      // Else if value is higher than index print empty star:
      } else if (index > _value) {
        return <FullStar starColor={emptyStarColor} empty />;

      // Otherwise print a full, colored in star:
      } else {
        return <FullStar starColor={starColor} />;
      }
    }}
    starColor={starColor}
    onChange={onChange}
    onStarClick={onStarClick}
    emptyStarColor={emptyStarColor}
    editing={editing}
    small={small}
    large={large}
    showTooltip={showTooltip}
  />
);

export default StarRating;

StarRating.propTypes = {
  className: PropTypes.string,
  editing: PropTypes.bool,
  emptyStarColor: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  small: PropTypes.bool,
  starColor: PropTypes.string,
  starCount: PropTypes.number,
  value: PropTypes.number,
  showTooltip: PropTypes.bool,
};

StarRating.defaultProps = {
  className: '',
  editing: false,
  emptyStarColor: '#ebebeb',
  name: '',
  onChange: () => {},
  renderStarIcon: undefined,
  starColor: '#FFC412',
  small: false,
  starCount: 5,
  value: null,
  showTooltip: false,
};
